module.exports = __webpack_public_path__ + "static/media/HomeConcept.16d5edb4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/HomeConcept.svg
// module id = 1858
// module chunks = 0